import messages from './onboarding.json' with { type: 'json' };

export const onboardingEn: Readonly<typeof messages> = messages;
